import React, { useEffect, useState } from "react";

import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  Typography,
  Slider,
  SliderValueLabelProps,
  Chip,
  Button,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../../common/SettingsAccordion";

import { enableAiSettingsModelArchitecture } from "../../../utils/config";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Preview,
} from "@mui/icons-material";
import { PasswordFieldWithVisibilityToggle } from "../../common/PasswordFieldWithVisibilityToggle";

const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 0.1,
    label: "1",
  },
  {
    value: 0.2,
    label: "2",
  },
  {
    value: 0.3,
    label: "3",
  },
  {
    value: 0.4,
    label: "4",
  },
  {
    value: 0.5,
    label: "5",
  },
  {
    value: 0.6,
    label: "6",
  },
  {
    value: 0.7,
    label: "7",
  },
  {
    value: 0.8,
    label: "8",
  },
  {
    value: 0.9,
    label: "9",
  },
  {
    value: 1,
    label: "10",
  },
];

interface IProps {
  name: string;
  accordionSettings: any;
  handleAccordionSettings: (name: string) => void;
  snackbarShowMessage: any;
  kbArticles: any;
  chatbotAISettings: any;
  setChatbotAISettings: (values: any) => void;
}

const AISettings = ({
  accordionSettings,
  chatbotAISettings,
  handleAccordionSettings,
  name,
  setChatbotAISettings,
  kbArticles,
}: IProps) => {
  const handleChange = (e: any, key: string) => {
    let { value } = e.target;

    if (key == "numberOfTriesBeforeRedirect" || key == "lengthOfResponse") {
      value = parseInt(value);
    }
    setChatbotAISettings({ ...chatbotAISettings, [key]: value });
  };

  const handleCheckbox = (e: any, key: string) => {
    setChatbotAISettings({
      ...chatbotAISettings,
      [key]: !chatbotAISettings[key],
    });
  };

  function sliderValueStyle(props: SliderValueLabelProps) {
    const { children, value } = props;

    return (
      <Tooltip
        enterTouchDelay={0}
        placement="top"
        title={value}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "white",
              color: "#0157FF",
              fontSize: 12,
            },
          },
        }}
      >
        {children}
      </Tooltip>
    );
  }
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    handleAccordionSettings(type);
  };
  return (
    <Accordion
      expanded={accordionSettings[name]}
      onChange={() => handleAccordionSettings(name)}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            AI Settings
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip
              title={
                <>
                  <Typography sx={{ fontSize: "12px" }}>
                    Chatbot Personality and Customization :
                  </Typography>
                  <Typography sx={{ fontSize: "11px" }}>
                    Customize bot model, tone, length and responses
                  </Typography>
                </>
              }
              placement="bottom"
            >
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} />
            </Tooltip>
          </Grid>
          <Grid item sx={{ marginLeft: 2, display: "flex" }}>
            {" "}
            <Tooltip
              title="Click to view the playground preview"
              placement="bottom"
            >
              <Preview />
            </Tooltip>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {kbArticles.length > 0 && (
            <Grid item xs={12}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>
                  Bot will reply based on the status of the selected
                  knowledgebase
                </InputLabel>
                <Select
                  labelId="kb-select"
                  id="kb-select"
                  value={chatbotAISettings.kbArticles || []}
                  label="kbarticle"
                  onChange={(e) => handleChange(e, "kbArticles")}
                  multiple
                  input={
                    <OutlinedInput id="select-multiple-chip" label="Chip" />
                  }
                  renderValue={(selected: any) => {
                    return (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((id: any) => {
                          return (
                            <Chip
                              key={id}
                              label={
                                kbArticles?.find(
                                  (article: any) => article.id === id
                                )?.name
                              }
                            />
                          );
                        })}
                      </Box>
                    );
                  }}
                >
                  {kbArticles?.map((value: any) => {
                    return (
                      <MenuItem key={value.id} value={value.id}>
                        {value.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} md={12}>
            <PasswordFieldWithVisibilityToggle
              placeHolder={"ChatGPT API key"}
              value={chatbotAISettings.openaiKey}
              fieldKey={"openaiKey"}
              onChange={(e) => handleChange(e, "openaiKey")}
              isMandatory={true}
            />
          </Grid>
          {enableAiSettingsModelArchitecture && (
            <>
              <Grid item xs={12}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Model Architecture KB Model Architecture
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>{" "}
                  </InputLabel>
                  <Select
                    labelId="size-select"
                    id="size-select"
                    value={chatbotAISettings.KBllmArchitecture}
                    label="size"
                    onChange={(e) => handleChange(e, "KBllmArchitecture")}
                  >
                    <MenuItem value="gpt4">GPT-4</MenuItem>
                    <MenuItem value="gpt3">GPT-3</MenuItem>
                    <MenuItem value="gpthybrid">GPT-Hybrid</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Model Architecture
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>{" "}
                  </InputLabel>
                  <Select
                    labelId="size-select"
                    id="size-select"
                    value={chatbotAISettings.llmArchitecture}
                    label="size"
                    onChange={(e) => handleChange(e, "llmArchitecture")}
                  >
                    <MenuItem value="gpt4">GPT-4</MenuItem>
                    <MenuItem value="gpt3">GPT-3</MenuItem>
                    <MenuItem value="gpthybrid">GPT-Hybrid</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Bot tone of conversation
                <div style={{ display: "inline-block", color: "red" }}>
                  *
                </div>{" "}
              </InputLabel>
              <Select
                labelId="size-select"
                id="size-select"
                value={chatbotAISettings.tone}
                label="size"
                onChange={(e) => handleChange(e, "tone")}
              >
                <MenuItem value="polite">Polite</MenuItem>
                <MenuItem value="humorous">Humorous</MenuItem>
                <MenuItem value="conversational">Conversational</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={11}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Approximate length of bots response
                <div style={{ display: "inline-block", color: "red" }}>
                  *
                </div>{" "}
              </InputLabel>

              <OutlinedInput
                type="number"
                inputProps={{ min: 50, max: 500 }}
                id="lor-select"
                label="Length of response"
                name="lengthOfResponse"
                value={chatbotAISettings.lengthOfResponse}
                onChange={(e) => handleChange(e, "lengthOfResponse")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={1}>
            <FormControl className="custom-select" fullWidth>
              <Typography className="title-sm1">Words</Typography>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                The number of retries by chatbot before redirecting to human
                support
              </InputLabel>

              <OutlinedInput
                type="number"
                inputProps={{ min: 0 }}
                id="not-select"
                label="Number of tries before it redirects"
                name="numberOfTriesBeforeRedirect"
                value={chatbotAISettings.numberOfTriesBeforeRedirect}
                onChange={(e) => handleChange(e, "numberOfTriesBeforeRedirect")}
              />
            </FormControl>
          </Grid>
          {chatbotAISettings.numberOfTriesBeforeRedirect &&
          chatbotAISettings.numberOfTriesBeforeRedirect >= 1 ? (
            <Grid item xs={12}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>
                  How bot will respond before redirecting to human support
                  <div style={{ display: "inline-block", color: "red" }}>
                    *
                  </div>{" "}
                </InputLabel>

                <OutlinedInput
                  type="text"
                  id="csr-select"
                  label="Customer support response"
                  name="customerSupportResponse"
                  value={chatbotAISettings.customerSupportResponse || ""}
                  onChange={(e) => handleChange(e, "customerSupportResponse")}
                />
              </FormControl>
            </Grid>
          ) : (
            <></>
          )}

          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => handleCheckbox(e, "useEmoji")}
                  checked={chatbotAISettings.useEmoji}
                  color="primary"
                />
              }
              label="Bot will use emojis in response"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => handleCheckbox(e, "allowGeneralQuestions")}
                  checked={chatbotAISettings.allowGeneralQuestions}
                  color="primary"
                />
              }
              label="Bot will answer questions not related to knowledgebase"
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                border: 1,
                borderColor: "#c3c6c8",
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Grid item xs={12}>
                <Typography className="title">
                  Bot creativity with responses
                </Typography>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Typography className="title-sm1">Less Creativity</Typography>
                <Typography className="title-sm1">More Creativity</Typography>
              </Box>
              <Grid item xs={12}>
                <Slider
                  disabled={false}
                  marks={marks}
                  step={0.1}
                  max={1}
                  min={0.1}
                  defaultValue={0.5}
                  value={chatbotAISettings.aiCreativity}
                  size="medium"
                  valueLabelDisplay="off"
                  color="primary"
                  onChange={(e) => handleChange(e, "aiCreativity")}
                  slots={{
                    valueLabel: sliderValueStyle,
                  }}
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <Tooltip title="Go to Pre AI Settings" placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "preAISettings", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>Go to Pre AI Settings</span>
            </Button>
          </Tooltip>
          <Tooltip title="Go to Text Settings" placement="bottom">
            <Button
              size="small"
              className="nextbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "generalSettings", "next");
              }}
            >
              &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
              <span>Go to Text Settings</span>
              <KeyboardArrowRight />
            </Button>
          </Tooltip>{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default withSnackbar(AISettings);
